/*
 * /search page enhancement — Reformation. When ?q= is present, AI-rank the
 * results. Loaded only by sections/main-search.liquid.
 *
 * Surgical swap: when the native search has results, the page renders a facets
 * sidebar + #ProductCount + #product-grid inside #ProductGridContainer. We
 * replace ONLY #product-grid's items (via AISearchClient.applyResults) so the
 * facets sidebar and the grid's column class (medium-up-{columns_desktop})
 * survive; the outer container is replaced only as a fallback when the native
 * search found zero results but AI found some.
 *
 * Faceting: if the URL already carries a filter.* param, we bail to native so
 * the faceted (server-ranked) results render — AI ranks the unfiltered query;
 * native owns faceting (documented limitation).
 *
 * Fail-soft: service null → native grid untouched (pre-paint guard reveals).
 */
(function () {
  function reveal() { try { if (window.__aiSwapReveal) window.__aiSwapReveal(); } catch (e) {} }
  if (!window.AISearchClient || !window.AISearchClient.ready()) { reveal(); return; }
  var params = new URLSearchParams(window.location.search);
  var q = (params.get('q') || '').trim();
  if (q.length < 2) { reveal(); return; }

  // Active facet filter → let native render the filtered, faceted results.
  var hasFilter = false;
  params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
  if (hasFilter) { reveal(); return; }

  var container = document.getElementById('ProductGridContainer');
  if (!container) { reveal(); return; }

  function prependCrossStore(data) {
    try {
      if (!window.AICrossStore || !window.AICrossStore.render) return;
      if (!data.crossStore || !data.crossStore.length) return;
      if (container.querySelector('.ai-xstore')) return;
      data.crossStore.forEach(function (b) {
        var panel = window.AICrossStore.render(b, q, false);
        if (panel) container.insertBefore(panel, container.firstChild);
      });
    } catch (e) {}
  }

  // When AI returns no products but has nearest-product suggestions, fill the
  // (now-empty) grid with those so an article-only/recall query still shops.
  function fillSuggestions(data) {
    try {
      if ((data.products || []).length || !(data.suggestions || []).length) return;
      window.AISearchClient.renderProductCards(data.suggestions, 'search').then(function (cards) {
        var grid = document.getElementById('product-grid');
        if (grid && !grid.children.length) grid.innerHTML = cards;
      }).catch(function () {});
    } catch (e) {}
  }

  window.AISearchClient.query(q)
    .then(function (data) {
      if (!data) { reveal(); return; } // service down → keep native results
      var total = (data.products || []).length + (data.articles || []).length;
      try { if (window.AISearchAnalytics) window.AISearchAnalytics.logSearch(q, total, 'search'); } catch (e) {}

      if (total === 0) {
        // Zero-result recovery: did-you-mean + review-led recommendations +
        // nearest-product suggestions + one deduped chip row.
        // High-confidence Health intent (cross-store-high) is a confident ANSWER,
        // not a failure — suppress failure copy so the cross-store panel leads cleanly.
        var isHealthHigh = !!(data.intent === 'cross-store-high' ||
          (data.crossStore || []).some(function (b) { return b && b.confidence === 'high'; }));
        try {
          var sugg = data.suggestions || [];
          var recent = (window.AISearchAnalytics ? window.AISearchAnalytics.getRecent() : [])
            .filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }).slice(0, 6);
          Promise.all([
            window.AISearchClient.trending(8).catch(function () { return []; }),
            window.AISearchClient.reviewsHighlights(2, null, q).catch(function () { return []; }),
          ]).then(function (res) {
            var popular = (res[0] || []).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }).slice(0, 8);
            var revs = res[1] || [];
            if (!sugg.length && !popular.length && !recent.length && !revs.length && !(data.crossStore || []).length) {
              reveal(); // nothing to recover with → native empty state stays
              return;
            }
            // Pass null for q when Health-high: renderDiscovery skips "No exact match" lead.
            window.AISearchClient.renderDiscovery(isHealthHigh ? null : q, popular, recent, sugg, revs, data.didYouMean || null)
              .then(function (html) {
                container.innerHTML = html;
                prependCrossStore(data); // cross-store leads the recovery
                window.AISearchClient.syncCounts(0, q);
                // Hide the native "0 results found for '…'" banner text too.
                if (isHealthHigh) {
                  document.querySelectorAll('.collection-banner p').forEach(function (el) {
                    if (/result/i.test(el.textContent) && /\d/.test(el.textContent)) {
                      el.style.display = 'none';
                    }
                  });
                }
                reveal();
              }, reveal);
          }).then(null, reveal);
        } catch (e) { reveal(); }
        return;
      }

      // Results exist: try the surgical patch (preserves facets + columns).
      window.AISearchClient.applyResults(data, 'search', q)
        .then(function (patched) {
          if (patched) {
            prependCrossStore(data);
            fillSuggestions(data);
            reveal();
            return;
          }
          // Native found zero but AI found results → standalone grid in the
          // outer container (no facets sidebar exists to preserve here).
          var cols = parseInt(container.getAttribute('data-ai-columns'), 10) || 4;
          window.AISearchClient.renderGridContainer(data, 'search', q, cols)
            .then(function (html) {
              container.innerHTML = html;
              prependCrossStore(data);
              window.AISearchClient.syncCounts(total, q);
              reveal();
            }, reveal);
        }, reveal);
    })
    .catch(reveal);
})();
